export default __webpack_public_path__ + "static/media/Perfect Teammate.9699630d.svg";